<script>
    export let clickCallback
    export let label

</script>

<button class="task-label" on:click={clickCallback}>{label}</button>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.task-label {
  font-size: 16px;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  cursor: pointer;
}
.task-label:hover {
  background: rgba(0, 0, 0, 0.25);
}</style>
